// client/src/components/admin/ManageBlogPosts.jsx

import React, { useState, useEffect } from "react";
import axios from "axios";
import PostComposer from "./PostComposer";

const ManageBlogPosts = () => {
    const [posts, setPosts] = useState([]);
    const [selectedPost, setSelectedPost] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Fetch all blog posts
        const fetchPosts = async () => {
            try {
                setIsLoading(true);
                const token = localStorage.getItem("token");
                const response = await axios.get("/api/blog", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                // Sort posts by createdAt in descending order
                const sortedPosts = response.data.sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );

                setPosts(sortedPosts);
            } catch (error) {
                console.error("Error fetching blog posts:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPosts();
    }, []);

    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`/api/blog/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setPosts(posts.filter((post) => post._id !== id));
        } catch (error) {
            console.error("Error deleting blog post:", error);
        }
    };

    const refreshPosts = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get("/api/blog", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setPosts(response.data);
        } catch (error) {
            console.error("Error refreshing posts:", error);
        }
    };

    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">Manage Blog Posts</h2>
            {selectedPost ? (
                <PostComposer
                    existingPost={selectedPost}
                    onSave={() => {
                        setSelectedPost(null);
                        refreshPosts();
                    }}
                    onCancel={() => setSelectedPost(null)}
                />
            ) : (
                <>
                    <button
                        onClick={() => setSelectedPost({})}
                        className="bg-green-500 text-white px-4 py-2 rounded mb-4"
                    >
                        Create New Post
                    </button>
                    {isLoading ? (
                        <p>Loading posts...</p>
                    ) : (
                        <ul className="space-y-4">
                            {posts.map((post) => (
                                <li key={post._id} className="border p-4 rounded">
                                    <h3 className="text-xl font-bold">{post.title}</h3>

                                    <p className="text-gray-600 text-sm">
                                        By {post.author}
                                    </p>
                                    <p className="text-gray-600 text-sm">
                                        Scheduled:{" "}
                                        {post.scheduleDate
                                            ? new Date(post.scheduleDate).toLocaleString()
                                            : "None"}
                                    </p>
                                    <p className="text-gray-600 text-sm">
                                        Expires:{" "}
                                        {post.expireDate
                                            ? new Date(post.expireDate).toLocaleString()
                                            : "None"}
                                    </p>
                                    <p className="text-gray-600 text-sm">
                                        Status: {post.isEnabled ? "Enabled" : "Disabled"} |{" "}
                                        {post.isPosted ? "Posted" : "Draft"}
                                    </p>
                                    <p className="text-blue-600 text-sm">
                                        Link:{" "}
                                        <a href={`/blog/${post.slug}`} target="_blank" rel="noopener noreferrer">
                                            {`/blog/${post.slug}`}
                                        </a>
                                    </p>
                                    <div className="flex space-x-4 mt-2">
                                        <button
                                            onClick={() => setSelectedPost(post)}
                                            className="bg-blue-500 text-white px-4 py-2 rounded"
                                        >
                                            Edit
                                        </button>
                                        <button
                                            onClick={() => handleDelete(post._id)}
                                            className="bg-red-500 text-white px-4 py-2 rounded"
                                        >
                                            Delete
                                        </button>
                                    </div>

                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </div>
    );
};

export default ManageBlogPosts;
